






























































































































import {Component, Vue} from 'vue-property-decorator'
import GasbotRiveAnimation from '@/components/gasbot/GasbotRiveAnimation.vue'

@Component({components: {GasbotRiveAnimation}})
export default class GasbotImageHeader extends Vue {}
